import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { PipelinePickup } from "../types";

type Props = {
  pickup: PipelinePickup;
};

export function DeliveryVerifiedCardContent({ pickup }: Props) {
  return (
    <Box sx={{ mt: 1.5, display: "flex", alignItems: "center", gap: 0.75 }}>
      <CheckCircleIcon sx={{ color: "#2E7D32", fontSize: 18 }} />
      <Typography variant="body2" fontWeight={600} color="#2E7D32" sx={{ fontSize: 13, lineHeight: 1.4 }}>
        Delivered {pickup.deliveredAt}
      </Typography>
    </Box>
  );
}
